import normalizeProduct from "./normalizeProduct";

export const normalizeProducts = (products) => {
    const normalizedProducts = products.map((product) => {
        return normalizeProduct(product)
    })
    return normalizedProducts
}

export default normalizeProducts